import { createFileRoute } from '@tanstack/react-router'

import BrandStorySection from '@/components/landing/BrandStorySection'
import FeaturesSection from '@/components/landing/FeaturesSection'
import HeroSection from '@/components/landing/HeroSection'
import LandingFooter from '@/components/landing/LandingFooter'
import LandingHeader from '@/components/landing/LandingHeader'
import NewsletterSignup from '@/components/NewsletterSignup'

export const Route = createFileRoute('/')({
  component: Home,
})

function Home() {
  return (
    <div className="min-h-screen bg-background">
      <LandingHeader />
      <main>
        <HeroSection />
        <FeaturesSection />
        <BrandStorySection />
        <NewsletterSignup />
      </main>
      <LandingFooter />
    </div>
  )
}
